module.exports = __webpack_public_path__ + "img/course1.57ec3099.png";